import {isPC, isTB} from './consist/config'

const hasHashParams = () => {
  if (window.location.hash !== '') {
    const $target = $('.x-hash-target')
    $('html, body').animate({
        scrollTop: $target.offset().top - 48
      },
      0);
  }
}

const initSwiper = () => {
  let _options = {
    loop: true,
    speed: 400,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        $('.x-clamp-title-swiper').shave(70, {spaces: false})
      }
    }
  }

  if (isPC || isTB) {
    Object.assign(_options, {
      slidesPerView: 3,
      spaceBetween: 15,
    })
  }

  let newSwiper = new Swiper('.swiper-container', _options)
}


const init = () => {
  initSwiper()

  hasHashParams()
}

const bind = () => {
  // $('.x-checkbox').on('click', function () {
  //   const $targetBtn = $('.x-btn-apply')
  //   let isChecked = $(this).prop('checked')
  //   if (isChecked) {
  //     $targetBtn.removeClass('disabled')
  //   } else {
  //     $targetBtn.addClass('disabled')
  //   }
  // })

  $('#videoModal').on('show.bs.modal', function () {
    $('video')[0].play()
  })

  $('#videoModal').on('hide.bs.modal', function () {
    $('video')[0].pause()
  })

}

$(function () {
  init()
  bind()
})
